import React, { useState, useEffect } from "react";
import "./style.scss";
import api from "../../api";
import { useAuth } from "../../context/AuthContext";
import { Link } from "react-router-dom";

const SLOT_COUNT = 2;

export default function SidebarRight() {
  const [ads, setAds] = useState([]);
  const [trialEnded, setTrialEnded] = useState(false);
  const [failedImages, setFailedImages] = useState({});
  const { isAuth, hasActiveSubscription } = useAuth();

  useEffect(() => {
    const fetchAds = async () => {
      try {
        const res = await api.get("/add-banners");
        const advisements = res.data?.data?.Advisement || [];

        const topRightAds = advisements
          .filter(
            (ad) =>
              (ad.position === "Top Right" || ad.position === "Bottom Right") &&
              ad.show === "1"
          )
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
          .slice(0, SLOT_COUNT);

        setAds(topRightAds);
        setFailedImages({});
      } catch (err) {
        console.error("Failed to load sidebar ads:", err.response?.data || err.message);
        setAds([]);
        setFailedImages({});
      }
    };

    fetchAds();
  }, []);

  const adSlots = Array.from({ length: SLOT_COUNT }, (_, i) => ads[i] || null);

  return (
    <aside className={`sidebar-right ${hasActiveSubscription ? "hide-sidebar" : ""}`}>
      {!trialEnded ? (
        <div className="ad-section">
          {adSlots.map((ad, index) => {
            const imageUrl = ad?.image_video || "";
            const isRenderable = Boolean(imageUrl) && !failedImages[ad?.id];

            return (
              !hasActiveSubscription && (
                <div key={ad?.id || `empty-slot-${index}`} className="ad-card">
                  {isRenderable ? (
                    <a href={ad?.url || "#"} target="_blank" rel="noopener noreferrer">
                      <img
                        src={imageUrl}
                        alt={ad?.title || "Advertisement"}
                        className="ad-image img-fluid"
                        onError={() =>
                          setFailedImages((prev) => ({
                            ...prev,
                            [ad.id]: true,
                          }))
                        }
                      />
                    </a>
                  ) : (
                    <div className="ad-image ad-image-empty" aria-hidden="true" />
                  )}
                </div>
              )
            );
          })}

          {isAuth && !hasActiveSubscription && (
            <div className="ad-label d-none d-md-block">Go add-free?</div>
          )}
          {isAuth && !hasActiveSubscription && (
            <div className="trials-sece d-none d-md-block">
              <Link to="/subscription" className="trial-complete-btn">
                Subscribe Now
              </Link>
            </div>
          )}
          {hasActiveSubscription && (
            <div className="ad-label d-none d-md-block">Enjoy add-free content</div>
          )}
          {hasActiveSubscription && (
            <div className="trials-sece d-none d-md-block">
              <button onClick={() => setTrialEnded(true)} className="trial-complete-btn">
                Subscription Status.
              </button>
            </div>
          )}
        </div>
      ) : (
        <div className="trial-ended-message d-none d-md-block">
          {hasActiveSubscription && <strong>You have an active subscription.</strong>}
          {!hasActiveSubscription && <span>You don't have an active subscription</span>}
        </div>
      )}
    </aside>
  );
}
